"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ReadMore_module_scss_1 = __importDefault(require("./ReadMore.module.scss"));
var ui_1 = require("@aperza/ui");
var defaultHeight = 85;
exports.ReadMore = function (props) {
    var text = props.text, className = props.className, _a = props.more, more = _a === void 0 ? 'More' : _a, _b = props.less, less = _b === void 0 ? 'Less' : _b, _c = props.line, line = _c === void 0 ? 4 : _c;
    var _d = react_1.useState(false), showMore = _d[0], setShowMore = _d[1];
    var _e = react_1.useState('76px'), collapseTextHeight = _e[0], setCollapseTextHeight = _e[1];
    var _f = react_1.useState('76px'), textHeight = _f[0], setTextHeight = _f[1];
    var hiddenEl = react_1.useRef(null);
    var toggle = function () {
        setShowMore(!showMore);
    };
    var fullTextHeight = function () {
        return hiddenEl && hiddenEl.current ? hiddenEl.current.clientHeight : defaultHeight;
    };
    var checkCollapseTextHeight = function () {
        if (text != null) {
            var lineHeight = parseFloat($('#readmore').css('line-height'));
            setCollapseTextHeight(lineHeight * line + 'px');
        }
    };
    var resize = function () {
        var height = fullTextHeight();
        setTextHeight('' + height);
    };
    ui_1.useWindowResize(resize);
    react_1.useEffect(function () {
        resize();
        checkCollapseTextHeight();
    }, [text]);
    return (react_1.default.createElement("div", { className: className + " " + ReadMore_module_scss_1.default.ReadMore },
        react_1.default.createElement("div", { className: ReadMore_module_scss_1.default.text, style: {
                height: showMore ? textHeight : collapseTextHeight,
                transition: 'height 300ms',
            } },
            react_1.default.createElement("p", { id: "readmore", className: ReadMore_module_scss_1.default.desc }, text)),
        fullTextHeight() >= defaultHeight && react_1.default.createElement("a", { onClick: toggle }, showMore ? less : more),
        react_1.default.createElement("div", { ref: hiddenEl, className: ReadMore_module_scss_1.default.hidden },
            react_1.default.createElement("p", { className: ReadMore_module_scss_1.default.desc }, text))));
};
